import React from 'react';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import SMSPreview from './sms/SMSPreview';
import EmailPreview from './email/EmailPreview';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';


const dialogWidth = 400;

const useStyles = makeStyles(() => ({
  select: {
    width : dialogWidth
  }
}));

const TemplatePreview = (props) => {
  const { t } = useTranslation();
  const classes = useStyles();

  const { open, data, handleClose, campaign, templateType } = props;


  let preview = '';
  if (templateType === 'sms' && data) {
    preview = <SMSPreview campaign={campaign} previewText={data.message_content} />;
  }

  if (templateType === 'email' && data) {
    preview = <EmailPreview className={classes.previewContainer} previewText={data.message_content} />;
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}>
      <DialogContent>
        {preview}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          {t('close')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TemplatePreview;
